const { sanitizer, validator } = require("indicative")

export default {
  install: (Vue: any, options: Record<any, any>) => {
    for (const item in options.validations) {
      validator.extend(item, options.validations[item])
    }
    for (const item in options.sanitizor) {
      sanitizer.extend[item] = options.sanitizor[item]
    }

    Vue.prototype.$indicative = async (data: object, rule: string) => {
      const validationClass = require(`@/validation/${rule}`)
      return validator.validateAll(
        data,
        validationClass.rules,
        validationClass.messages,
        validationClass.sanitizationRules
      )
    }
  },
}
